var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2987_57803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1693 24.0002C17.0376 24.0009 16.9072 23.9757 16.7853 23.9259C16.6635 23.8762 16.5527 23.8028 16.4592 23.7102L8.28925 15.5402C7.82362 15.0757 7.45419 14.524 7.20213 13.9165C6.95006 13.3091 6.82031 12.6578 6.82031 12.0002C6.82031 11.3425 6.95006 10.6913 7.20213 10.0838C7.45419 9.47639 7.82362 8.92463 8.28925 8.46017L16.4592 0.290185C16.5525 0.196947 16.6632 0.122986 16.785 0.0725256C16.9068 0.0220653 17.0374 -0.00390625 17.1693 -0.00390625C17.3011 -0.00390625 17.4317 0.0220653 17.5535 0.0725256C17.6753 0.122986 17.786 0.196947 17.8792 0.290185C17.9725 0.383423 18.0465 0.494114 18.0969 0.615935C18.1474 0.737757 18.1733 0.868325 18.1733 1.00018C18.1733 1.13204 18.1474 1.26261 18.0969 1.38443C18.0465 1.50625 17.9725 1.61694 17.8792 1.71018L9.70925 9.88017C9.14745 10.4427 8.83189 11.2052 8.83189 12.0002C8.83189 12.7952 9.14745 13.5577 9.70925 14.1202L17.8792 22.2902C17.973 22.3831 18.0474 22.4937 18.0981 22.6156C18.1489 22.7374 18.175 22.8681 18.175 23.0002C18.175 23.1322 18.1489 23.2629 18.0981 23.3847C18.0474 23.5066 17.973 23.6172 17.8792 23.7102C17.7858 23.8028 17.675 23.8762 17.5532 23.9259C17.4313 23.9757 17.3009 24.0009 17.1693 24.0002Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2987_57803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiBackIcon);
export default __webpack_public_path__ + "static/media/tildi-back-icon.0e769a690b6d09ce625cba0d286bbfc5.svg";
export { ForwardRef as ReactComponent };